import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: '📊',
      title: 'داشبورد جامع',
      description: 'مشاهده وضعیت کل پورتفوی خود در یک نگاه با نمودارهای تعاملی'
    },
    {
      icon: '📈',
      title: 'تحلیل تکنیکال',
      description: 'ابزارهای پیشرفته برای تحلیل سهام و شناسایی فرصت‌های معاملاتی'
    },
    {
      icon: '🔄',
      title: 'استراتژی چرخه',
      description: 'پیاده‌سازی استراتژی Wheel Strategy برای درآمد ثابت'
    },
    {
      icon: '📋',
      title: 'مدیریت معاملات',
      description: 'ثبت و پیگیری تمام معاملات با ابزارهای تحلیلی قدرتمند'
    },
    {
      icon: '💰',
      title: 'حسابداری هوشمند',
      description: 'محاسبه خودکار سود، زیان و کمیسیون‌های معاملاتی'
    }
  ];

  const stats = [
    { value: '۱۰,۰۰۰+', label: 'کاربران فعال' },
    { value: '۵۰۰+', label: 'ابزار تحلیلی' },
    { value: '۲۴/۷', label: 'پشتیبانی' }
  ];

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="landing-header">
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <span className="logo-icon">💹</span>
              <span className="logo-text">پورتفوی هوشمند</span>
            </div>
            <nav className="header-nav">
              <button onClick={() => navigate('/login')} className="btn btn-outline">
                ورود
              </button>
              <button onClick={() => navigate('/register')} className="btn btn-primary">
                ثبت‌نام رایگان
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-bg"></div>
        <div className="container">
          <div className="hero-content">
            <span className="hero-badge">✨ نسل جدید مدیریت سرمایه</span>
            <h1 className="hero-title">
              مدیریت هوشمند
              <span className="gradient-text"> پورتفوی </span>
              سرمایه‌گذاری
            </h1>
            <p className="hero-description">
              پلتفرم جامع برای مدیریت، تحلیل و بهینه‌سازی سبد سرمایه‌گذاری شما.
              با ابزارهای پیشرفته و سیگنال‌های هوشمند، تصمیمات بهتری بگیرید.
            </p>
            <div className="hero-buttons">
              <button onClick={() => navigate('/register')} className="btn btn-primary btn-lg">
                شروع رایگان
                <span className="btn-icon">🚀</span>
              </button>
              <button className="btn btn-outline btn-lg">
                مشاهده دمو
                <span className="btn-icon">▶️</span>
              </button>
            </div>
            <div className="hero-stats">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <span className="stat-value">{stat.value}</span>
                  <span className="stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">ویژگی‌ها</span>
            <h2 className="section-title">همه چیز برای مدیریت حرفه‌ای</h2>
            <p className="section-description">
              ابزارهای قدرتمند برای تحلیل، معامله و مدیریت هوشمند سرمایه
            </p>
          </div>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="cta-content">
              <h2 className="cta-title">آماده شروع هستید؟</h2>
              <p className="cta-description">
                همین الان ثبت‌نام کنید و از تمام امکانات پلتفرم به صورت رایگان استفاده کنید
              </p>
              <div className="cta-buttons">
                <button onClick={() => navigate('/register')} className="btn btn-primary btn-lg">
                  ثبت‌نام رایگان
                </button>
                <button onClick={() => navigate('/login')} className="btn btn-outline btn-lg">
                  ورود به حساب
                </button>
              </div>
            </div>
            <div className="cta-decoration">
              <div className="decoration-circle decoration-1"></div>
              <div className="decoration-circle decoration-2"></div>
              <div className="decoration-circle decoration-3"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <div className="logo">
                <span className="logo-icon">💹</span>
                <span className="logo-text">پورتفوی هوشمند</span>
              </div>
              <p className="footer-tagline">
                پلتفرم جامع مدیریت سرمایه‌گذاری
              </p>
            </div>
            <div className="footer-links">
              <div className="footer-column">
                <h4>محصولات</h4>
                <ul>
                  <li><a href="#">داشبورد</a></li>
                  <li><a href="#">سیگنال‌ها</a></li>
                  <li><a href="#">آپشن چین</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>شرکت</h4>
                <ul>
                  <li><a href="#">درباره ما</a></li>
                  <li><a href="#">تماس با ما</a></li>
                  <li><a href="#">قوانین</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>پشتیبانی</h4>
                <ul>
                  <li><a href="#">راهنما</a></li>
                  <li><a href="#">سوالات متداول</a></li>
                  <li><a href="#">تلگرام</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© ۱۴۰۴ تمام حقوق محفوظ است</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
